"use client";
import React from "react";
import { usePathname } from "@/i18n/navigation";
import ImageCropper from "../imageEditorTools/imageCropper/ImageCropper";
import ImageFilters from "../imageEditorTools/imageFilters/ImageFilter";
import ImageResize from "../imageEditorTools/imageResize/ImageResize";
import ImageColorExtractor from "../imageEditorTools/imageColorExtractor/ImageColorExtractor";
import GetYourColor from "../imageEditorTools/getYourColor/GetYourColor";
import ImageColorPicker from "../imageEditorTools/imageColorPicker/ImageColorPicker";
import ImageCompressor from "../imageEditorTools/imageCompressor/ImageCompressor";
import BaseToImage from "../imageEditorTools/Base64ToImage/BaseToImage";
import ImageToBase from "../imageEditorTools/ImageToBase64/ImageToBase";
import TextToImg from "../imageEditorTools/TextToImage/TextToImg";
import ImageCombine from "../imageEditorTools/imageCombine/ImageCombine";
import { ParaData } from "../common/CommonArray/FileArray";
import { HowToUseText } from "@/common/ToolPara";

const routeConfig = {
  "/image-compressor": {
    toolName: "Image Compressor",
    paraData: ParaData.IMAGE_COMPRESSOR,
  },
  // Add more image tool routes here as we expand them
};

function ImgEditorFormat() {
  const pathname = usePathname();
  const currentRoute = routeConfig[pathname];

  return (
    <>
      {pathname === "/image-cropper" && <ImageCropper />}
      {pathname === "/image-filters" && <ImageFilters />}
      {pathname === "/image-resize" && <ImageResize />}
      {pathname === "/image-compressor" && <ImageCompressor />}
      {pathname === "/image-color-extractor" && <ImageColorExtractor />}
      {pathname === "/get-your-color" && <GetYourColor />}
      {pathname === "/image-color-picker" && <ImageColorPicker />}
      {pathname === "/image-to-base64-convertor" && <ImageToBase />}
      {pathname === "/base64-to-image-convertor" && <BaseToImage />}
      {pathname === "/text-to-image-convertor" && <TextToImg />}
      {pathname === "/combine-image" && <ImageCombine />}
      {currentRoute && (
        <HowToUseText
          toolName={currentRoute.toolName}
          firstPata={currentRoute.paraData.firstPara}
          secondPara={currentRoute.paraData.secondPara}
          toolData={currentRoute.paraData.toolData}
          howToUse={currentRoute.paraData.howToUse}
          whyUse={currentRoute.paraData.whyUse}
          commonUseCases={currentRoute.paraData.commonUseCases}
          features={currentRoute.paraData.features}
          faq={currentRoute.paraData.faq}
          tips={currentRoute.paraData.tips}
          relatedTools={currentRoute.paraData.relatedTools}
        />
      )}
    </>
  );
}

export default ImgEditorFormat;
